import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import {useRouteMatch} from 'react-router-dom';
import PropTypes from 'prop-types';
import {useDispatch} from "react-redux";
import {getFileList} from '../../../common/actions/files/getFileList';
import {getOrderFilesList} from '../../../common/actions/files/getSharedOrPrivateFilesList';
import {pathnames as P} from "common/constants/pathnames";
import {getFile} from "../../../common/actions/files/getFile";
import {downloadFile} from "../../../common/utils/files/downloadFile";
import {deleteFile} from "../../Inspection/actions/files/deleteFile";
import {uploadFile} from "../../Inspection/actions/files/uploadFile";
import {closeInspection} from "../../Inspection/actions/closeInspection";
import {copyOrderFile} from "../../../common/actions/files/copySharedFile";
import {showGlobalErrorMessage} from "../../../common/actions/globalErrorMessage/showGlobalErrorMessage";
import {errors as E} from '../../../common/constants/errors';


const InspectionOtherFilesContext = createContext('');

export function useInspectionOtherFilesContext() {
  return useContext(InspectionOtherFilesContext);
}

export function InspectionOtherFilesProvider({children}) {
  const [data, setData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [uploading, setUploading] = useState(false);

  const dispatch = useDispatch();
  const {params} = useRouteMatch(P.INSPECTION_OTHER_ID);
  const shumaId = parseInt(params.shumaId, 10);

  useEffect(() => {
    if (shumaId) {
      dispatch(getFileList({shumaId}))
        .then(setData)
        .catch(e => {
          dispatch(showGlobalErrorMessage(E.SERVER_ERROR))
          console.error(e)
        })
    }
  }, []);
  const fileList = Boolean(data?.fileList) ? data?.fileList : [];

  const getOrderFileList = (fileTypeID) => {
    getOrderFilesList({shumaID: shumaId, fileTypeID})
      .then(setOrderData)
      .catch(e => {
        dispatch(showGlobalErrorMessage(E.SERVER_ERROR))
        console.error(e)
      })
  };
  const orderFileList = Boolean(orderData?.orderFilesList) ? orderData?.orderFilesList : [];

  const handleDownloadFile = (fileID, fileName) => {
    dispatch(getFile({shumaId, fileID}))
      .then(file => downloadFile(`data:;base64,${file}`, fileName))
      .catch(e => {
        dispatch(showGlobalErrorMessage(E.SERVER_ERROR))
        console.error(e)
      })
  };
  const handleDeleteFile = (fileID) => {
    dispatch(deleteFile({shumaId, fileID}))
      .then(() => dispatch(getFileList({shumaId})))
      .then(setData)
      .catch(e => {
        dispatch(showGlobalErrorMessage(E.SERVER_ERROR))
        console.error(e)
      })
  };
  const handleUploadFile = (file, fileTypeId, folderID = null) => {
    const fileToSave = file;
    const filename = file.name;
    setUploading(true);
    dispatch(uploadFile({
      fileToSave, shumaId, fileTypeId, filename, folderID
    }))
      .then(() => {
        if (fileTypeId === 21) {
          closeInspection(shumaId)
        }
      })
      .then(() => dispatch(getFileList({shumaId})))
      .then(setData)
      .then(() => document.body.click())
      .catch(e => {
        dispatch(showGlobalErrorMessage(E.SERVER_ERROR))
        console.error(e)
      })
      .finally(() => setTimeout(() => {
        setUploading(false)
      }, 1000))
  };
  const handleUploadMultipleFiles = async (files, fileTypeId, folderID = null) => {
    setUploading(true);
    const filesArray = files && files.length > 0 ? Object.values(files) : [];
    const calls = filesArray.length > 0 && filesArray.map(async (item) => {
      await dispatch(uploadFile({
        fileToSave: item, shumaId, fileTypeId, filename: item.name, folderID
      }))
    });
    const results = await Promise.all(calls);
    if (results) {
      dispatch(getFileList({shumaId}))
        .then(setData)
        .then(() => document.body.click())
    }
    setUploading(false);
  };
  const handleSelectFile = (fileTypeID, fileID) => {
    copyOrderFile(shumaId, fileID, fileTypeID)
      .then(() => {
        if (fileTypeID === 21) {
          closeInspection(shumaId)
        }
      })
      .then(() => dispatch(getFileList({shumaId})))
      .then(setData)
      .catch(e => {
        dispatch(showGlobalErrorMessage(E.SERVER_ERROR))
        console.error(e)
      })
  };

  const value = {
    fileList,
    orderFileList,
    uploading,
    fileActions: {
      getFileList,
      handleDownloadFile,
      handleDeleteFile,
      handleUploadFile,
      handleUploadMultipleFiles,
      getOrderFileList,
      handleSelectFile,
    }
  };

  return (
    <InspectionOtherFilesContext.Provider value={value}>
      {children}
    </InspectionOtherFilesContext.Provider>
  );
}

InspectionOtherFilesProvider.propTypes = {
  children: PropTypes.node,
};
